var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "skip-logic-editor"
  }, [_c('v-text-field', {
    staticClass: "skip-logic-editor__conditional-field",
    attrs: {
      "value": _vm.fieldObj.title,
      "outlined": "",
      "disabled": "",
      "dense": "",
      "hide-details": ""
    },
    scopedSlots: _vm._u([{
      key: "prepend-inner",
      fn: function () {
        return [_c(_vm.fieldConst.ICON_COMPONENT, {
          tag: "component"
        }), _vm._v(" " + _vm._s(_vm.fieldLocation) + " ")];
      },
      proxy: true
    }])
  }), _c('div', {
    staticClass: "skip-logic-options"
  }, [_c('f-autocomplete', {
    ref: "skipLogicAutocomplete",
    staticClass: "skip-logic-options__autocomplete",
    attrs: {
      "items": _vm.allOptions,
      "item-value": function (item) {
        return item.index;
      },
      "filter": function (item, search) {
        return item.text.toLocaleLowerCase().includes(search.toLocaleLowerCase());
      },
      "placeholder": "Add option",
      "menu-props": {
        maxWidth: _vm.optionsMenuWidth,
        minWidth: _vm.optionsMenuWidth,
        nudgeRight: _vm.optionsMenuNudgeRight,
        nudgeBottom: 6,
        closeOnClick: true
      },
      "multiple": "",
      "outlined": "",
      "deletable-chips": "",
      "hide-details": "",
      "dense": ""
    },
    scopedSlots: _vm._u([{
      key: "prepend-inner",
      fn: function () {
        return [_c('span', {
          ref: "skipLogicLabel",
          staticClass: "skip-logic-options__inline-label"
        }, [_vm._v("If selected")])];
      },
      proxy: true
    }, {
      key: "item",
      fn: function (_ref) {
        var on = _ref.on,
          item = _ref.item,
          attrs = _ref.attrs;
        return [_c('v-list-item', _vm._g(_vm._b({}, 'v-list-item', attrs, false), on), [_c('v-list-item-content', [_c('v-list-item-title', [_vm._v(" " + _vm._s(_vm.formatOptionLabel(item)) + " ")])], 1)], 1)];
      }
    }, {
      key: "selection",
      fn: function (_ref2) {
        var item = _ref2.item,
          parent = _ref2.parent;
        return [_c('v-chip', {
          key: JSON.stringify(item),
          staticClass: "skip-logic-options__chip my-1",
          attrs: {
            "label": "",
            "small": ""
          }
        }, [_c('span', {
          staticClass: "text-truncate"
        }, [_vm._v(_vm._s(_vm.formatOptionLabel(item)))]), _c('XIcon', {
          staticClass: "cursor-pointer ml-1",
          attrs: {
            "size": "12"
          },
          on: {
            "click": function ($event) {
              return parent.selectItem(item);
            }
          }
        })], 1)];
      }
    }]),
    model: {
      value: _vm.selectedOptionsIndexes,
      callback: function ($$v) {
        _vm.selectedOptionsIndexes = $$v;
      },
      expression: "selectedOptionsIndexes"
    }
  })], 1), _vm.selectedOptions.length > 0 ? _c('div', {
    staticClass: "skip-logic-destinations"
  }, [_c('div', {
    staticClass: "skip-logic-destinations__label"
  }, [_vm._v("Skip to")]), _vm._l(_vm.selectedOptions, function (option) {
    return _c('div', {
      key: option.index,
      staticClass: "skip-logic-destination"
    }, [_c('DestinationSelector', {
      attrs: {
        "option": option,
        "current-field-id": _vm.fieldId,
        "destination": _vm.getOptionDestination(option),
        "already-selected-field-ids": _vm.getOtherSelectedFieldIds(option)
      },
      on: {
        "update-destination": _vm.updateDestination
      }
    })], 1);
  })], 2) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }